import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, FileText } from 'lucide-react';
import { SourceOverlay } from './SourceOverlay';
interface SourceAnnotationProps {
  children: React.ReactNode;
  sourceType: 'email' | 'document';
  sourceTitle: string;
  sourceDate: string;
  extractedValue: string;
  context?: string;
  className?: string;
}
export function SourceAnnotation({
  children,
  sourceType,
  sourceTitle,
  sourceDate,
  extractedValue,
  context,
  className = ''
}: SourceAnnotationProps) {
  const [isHovered, setIsHovered] = useState(false);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const isEmail = sourceType === 'email';
  const Icon = isEmail ? Mail : FileText;
  const badgeColors = isEmail ? 'bg-teal-50 text-teal-700 border-teal-200' : 'bg-blue-50 text-blue-700 border-blue-200';
  const caretColor = isEmail ? 'border-t-teal-200' : 'border-t-blue-200';
  return <>
      <span className={`relative inline-block cursor-help ${className}`} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onClick={e => {
      e.stopPropagation();
      setIsOverlayOpen(true);
    }} data-id="element-717">
        {/* The wrapped content */}
        <span className={`transition-colors duration-200 ${isHovered ? isEmail ? 'bg-teal-50/50 border-b border-teal-200' : 'bg-blue-50/50 border-b border-blue-200' : 'border-b border-transparent'} rounded-sm px-0.5 -mx-0.5`} data-id="element-718">
          {children}
        </span>

        {/* Floating Badge */}
        <AnimatePresence data-id="element-719">
          {isHovered && <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 2
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 2
        }} transition={{
          duration: 0.1,
          ease: 'easeOut'
        }} className="absolute bottom-full right-0 mb-1.5 z-50 pointer-events-none" data-id="element-720">
              <div className={`flex items-center gap-1.5 px-2 py-1 rounded border ${badgeColors}`} data-id="element-721">
                <Icon className="w-3 h-3" data-id="element-722" />
                <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-723">
                  {isEmail ? 'Email' : 'PDF'}
                </span>
              </div>
              {/* Caret pointing down to the text */}
              <div className={`absolute -bottom-1 right-3 w-0 h-0 border-l-[4px] border-r-[4px] border-t-[4px] border-l-transparent border-r-transparent ${caretColor}`} data-id="element-724" />
            </motion.div>}
        </AnimatePresence>
      </span>

      {/* Full Screen Overlay */}
      <SourceOverlay isOpen={isOverlayOpen} onClose={() => setIsOverlayOpen(false)} sourceType={sourceType} sourceTitle={sourceTitle} sourceDate={sourceDate} extractedValue={extractedValue} context={context} data-id="element-725" />
    </>;
}